import { render } from "./PublicSessionPage.vue?vue&type=template&id=641a1bba&scoped=true"
import script from "./PublicSessionPage.vue?vue&type=script&lang=js"
export * from "./PublicSessionPage.vue?vue&type=script&lang=js"

import "./PublicSessionPage.vue?vue&type=style&index=0&id=641a1bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641a1bba"]])

export default __exports__